<script setup lang="ts">
import { useVersionCheck } from '@/composables/useVersionCheck'

const { updateAvailable, refresh } = useVersionCheck()
</script>

<template>
  <div
    v-if="updateAvailable"
    class="fixed bottom-4 left-0 right-0 z-50 mx-auto flex w-[calc(100%-2rem)] max-w-md items-center justify-between gap-4 rounded-xl bg-[#1b325a] px-5 py-4 text-white shadow-lg"
  >
    <div class="flex flex-col gap-1">
      <span class="text-sm font-bold">نسخه جدیدی از پنل منتشر شده است</span>
      <span class="text-xs text-white/80">برای دریافت آخرین تغییرات، صفحه را به‌روزرسانی کنید.</span>
    </div>
    <button
      type="button"
      class="shrink-0 rounded-lg bg-white px-4 py-2 text-sm font-bold text-[#1b325a] transition hover:bg-gray-100"
      @click="refresh"
    >
      به‌روزرسانی
    </button>
  </div>
</template>
